var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog--loader"},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-text',[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"size":70,"indeterminate":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dc67334","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DialogLoader.vue
// module id = iQRC
// module chunks = 1